<template>
    <div class="slider" v-for="filter in filters" :key="filter.Id">
        <div class="slider-range" style="display: flex; justify-content: space-between">
            <div class="slider__min">0km</div>
            <div class="slider__max">100km</div>
        </div>
        <slider
            :height="24"
            :always-show-handle="true"
            :handleScale="0.9"
            v-model="vmRangeValue"
            :class="{
                'arl-slider is-load': isLoad,
                'arl-slider is-start': isStart,
                'arl-slider is-end': isEnd,
            }"
            color="#FF7609"
            track-color="#E8E9EF"
            @dragging="onDragging(filter, vmRangeValue)"
            @drag-end="onDragEnd(alias, filter, vmRangeValue)" />
    </div>
</template>

<script setup lang="ts">
// Vue
import { watch, ref, onMounted } from 'vue';

// Pinia
import { storeToRefs } from 'pinia';

// Composable
import { useSearchParamUpdate } from '../../composables/useSearchParamUpdate';

// Store
import { useRidingschoolStore } from '../../apps/ridingschool/store/ridingschool.store';

// Vendor
import slider from 'vue3-slider';

// Model
import { IRangeType } from '../../apps/ridingschool/model/ridingschool.models';

const ridingschoolStore = useRidingschoolStore();
const { resetComponentState } = storeToRefs(ridingschoolStore);

const vmRangeValue = ref<number>(0);

const isStart = ref(true);
const isEnd = ref(false);
const isLoad = ref(false);

const props = defineProps<{
    alias: string;
    filters: IRangeType[];
}>();

function onDragging(filter: IRangeType, val: number) {
    if (val === filter.Min) {
        isStart.value = true;
        isEnd.value = false;
        isLoad.value = false;
    } else if (val === filter.Max) {
        isStart.value = false;
        isEnd.value = true;
        isLoad.value = false;
    } else {
        isStart.value = false;
        isEnd.value = true;
        isLoad.value = false;
    }
}

function onDragEnd(alias: string, filter: IRangeType, val: number) {
    onDragging(filter, val);

    useSearchParamUpdate(ridingschoolStore, 'remove', 'page', '');
    useSearchParamUpdate(ridingschoolStore, 'update', alias, vmRangeValue.value.toString());
}

function handleRangeState() {
    if (ridingschoolStore.searchParams?.get(props.alias) !== null) {
        vmRangeValue.value = parseInt(ridingschoolStore.searchParams?.get(props.alias));
    } else {
        vmRangeValue.value = 0;
        isLoad.value = true;
        isStart.value = true;
    }
}

watch(resetComponentState, (newState, oldState) => {
    handleRangeState();
});

onMounted(() => {
    const aliasParam = ridingschoolStore.searchParams?.get(props.alias) ?? '15';

    if (aliasParam) {
        isLoad.value = true;
        isStart.value = aliasParam === '0';
        isEnd.value = aliasParam !== '0';
        const range = ref<string>(aliasParam);

        useSearchParamUpdate(ridingschoolStore, 'update', props.alias, range.value);
        vmRangeValue.value = parseInt(range.value);
    }
    handleRangeState();
});
</script>
